module.exports = __webpack_public_path__ + "static/img/Horizontal DHD Logo for Dark Backgrounds.3b3f728.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Horizontal DHD Logo for Dark Backgrounds.png
// module id = md73
// module chunks = 1